import { useEffect, useState, lazy } from "react";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import {
  closeUpdateModelData,
  openAddModelData,
  setNewPackageModelTrue,
} from "../../store/slices/modalSlice";
import { PackageDetails, ServiceData } from "../../types/serviceDetail";
import ServiceOption from "../serviceDetails/ServiceOption";
import ServiceInformation from "../serviceDetails/ServiceInformation";
import ChannelPartner from "../serviceDetails/ChannelPartner";
import ServiceRejection from "../serviceDetails/ServiceRejection";
import ServiceStep from "../serviceDetails/ServiceStep";
import AboutService from "../serviceDetails/AboutService";
import ServiceEmirate from "../serviceDetails/ServiceEmirate";
import ServiceReview from "../serviceDetails/ServiceReview";
import ServiceFaq from "../serviceDetails/ServiceFaq";
import Service from "../serviceDetails/Service";
import ServiceInfo from "../serviceDetails/ServiceInfo";
import SomeThingWentWrong from "../somethingwentwrong/SomeThingWentWrong";
import PackageSection from "../serviceDetails/PackageSection";
import ServiceProcessGif from "../serviceDetails/ServiceProcessGif";
import ServiceEmirateSingle from "../serviceDetails/ServiceEmirateSingle";
import { Modal } from "react-bootstrap";

const DotLottieReact = lazy(() =>
  import("@lottiefiles/dotlottie-react").then((module) => ({
    default: module.DotLottieReact,
  }))
);

const baseUrl = import.meta.env.VITE_API_URL;

interface Price {
  PriceRecordId: number;
  PriceServiceName: string;
  PriceType: string;
  PriceAmount: number;
  PriceCurrency: string;
  Description: string | null;
  serviceName: string;
  serviceid: number;
  OldPriceAmount: number;
}

const UpdateModel = () => {
  const dispatch = useDispatch();
  const updateModalOpen = useSelector(
    (state: { modal: { updateModelData: boolean } }) =>
      state.modal.updateModelData
  );
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [priceData, setPriceData] = useState<Price[]>([]);
  const [serviceDetail, setServiceData] = useState<ServiceData>();
  const [selectedService, setSelectedService] = useState<PackageDetails | null>(
    null
  );

  const handleCloseUpdateModal = () => {
    sessionStorage.removeItem("serviceid");
    sessionStorage.removeItem("packageId");
    sessionStorage.removeItem("packageMainId");
    dispatch(closeUpdateModelData());
  };

  const handleProceedButton = () => {
    // if (serviceDetail?.isType === "groupPackage") {
    //   sessionStorage.setItem(
    //     "packageId",
    //     JSON.stringify(selectedService?.RecordId)
    //   );
    // }
    if (selectedService?.PackageMainId) {
      sessionStorage.setItem(
        "packageMainId",
        JSON.stringify(selectedService?.PackageMainId)
      );
    }
    dispatch(closeUpdateModelData());
    if (serviceDetail?.serviceInfo?.component && ( (serviceDetail?.serviceInfo?.component).toLocaleLowerCase() === 'departmentpages'))
      dispatch(openAddModelData());
    else dispatch(setNewPackageModelTrue());
  };

  const getData = async (ServiceId: string) => {
    try {
      setIsLoading(true);
      setIsError(false);
      const modelPopup = await axios.post(
        `${baseUrl}/api/services/service-popup`,
        { ServiceId },
        {
          headers: { "Content-Type": "application/json" },
        }
      );
      setServiceData(modelPopup.data);
      setPriceData(modelPopup.data?.serviceInfo?.priceData ?? []);
    } catch (error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    import("./updateModel.css");
    const serviceid = sessionStorage.getItem("serviceid");
    if (serviceid) getData(serviceid);

    const script = document.createElement("script");
    script.src = "https://static.elfsight.com/platform/platform.js";
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  if (isError) {
    return <SomeThingWentWrong />;
  }

  return (
    <Modal
      show={updateModalOpen}
      onHide={handleCloseUpdateModal}
      scrollable
      backdrop="static"
      centered
      className="mb-fix slide-from-bottom"
    >
      <Modal.Header closeButton>
        {/* <Modal.Title>Amer Services</Modal.Title> */}
      </Modal.Header>
      <Modal.Body className="modal-dialog-scrollable pt-0">
        {isLoading ? (
          <div className="container d-flex flex-column align-items-center justify-content-center gap-4">
            <div className="p-10 m-10">
              <DotLottieReact
                src="https://lottie.host/e06766cd-c697-4ee0-a6f2-4ad3cfaf5ec1/52PAvyt8wm.lottie"
                loop
                autoplay
              />
            </div>
          </div>
        ) : (
          <>
            {serviceDetail?.serviceInfo && (
              <Service
                service={serviceDetail.serviceInfo}
                priceData={priceData}
                slugUrl={serviceDetail?.serviceReview?.sub1Slug}
                isPackage={serviceDetail?.isPackage}
                type={serviceDetail?.isType}
                selectedService={selectedService}
                handleProceedButton={handleProceedButton}
              />
            )}

            {serviceDetail?.isPackage && serviceDetail?.packageDetails && (
              <PackageSection
                type={serviceDetail.isType}
                packageDetails={serviceDetail.packageDetails}
                sectionTitle={serviceDetail?.allTitles?.section_4_title}
                line={serviceDetail?.allTitles?.section_4_line}
                setSelectedService={setSelectedService}
                selectedService={selectedService}
                serviceInformation={{
                  details: serviceDetail.serviceInformation,
                  title: serviceDetail?.allTitles?.section_2_title,
                  line: serviceDetail?.allTitles?.section_2_line,
                }}
              />
            )}
            {/* <h1> ljljl</h1> {priceData && <ServicePriceOption priceData={priceData} />} */}
            {serviceDetail?.serviceOption?.length !== 0 &&
              serviceDetail?.allTitles && (
                <ServiceOption
                  serviceOption={serviceDetail.serviceOption}
                  sectionTitle={serviceDetail.allTitles.section_1_title}
                  line={serviceDetail.allTitles.section_1_line}
                />
              )}

            {serviceDetail?.isPackage && serviceDetail?.isType !== "package" ? (
              serviceDetail?.serviceInformation.length !== 0 &&
              serviceDetail?.allTitles && (
                <ServiceProcessGif
                  sectionTitle={serviceDetail.allTitles.section_3_title}
                  line={serviceDetail.allTitles.section_3_line}
                />
              )
            ) : (
              <>
                {serviceDetail?.serviceInformation.length !== 0 &&
                  serviceDetail?.allTitles && (
                    <ServiceInformation
                      serviceInformations={serviceDetail?.serviceInformation}
                      sectionTitle={serviceDetail.allTitles.section_2_title}
                      line={serviceDetail.allTitles.section_2_line}
                    />
                  )}
                {serviceDetail?.requireDocs && serviceDetail?.allTitles && (
                  <ServiceInfo
                    requireDocs={serviceDetail?.requireDocs}
                    importantNotes={serviceDetail?.importantDocs}
                    sectionTitle={serviceDetail.allTitles.section_4_title}
                    line={serviceDetail.allTitles.section_4_line}
                    sectionTitle2={serviceDetail.allTitles.section_3_title}
                    line2={serviceDetail.allTitles.section_3_line}
                  />
                )}
              </>
            )}

            {/* {serviceDetail?.allTitles && (
              <ServiceProcessGif
                sectionTitle={serviceDetail.allTitles.section_3_title}
                line={serviceDetail.allTitles.section_3_line}
              />
            )}

            {serviceDetail?.requireDocs &&
              serviceDetail?.importantDocs &&
              serviceDetail?.allTitles && (
                <ServiceRequiredDoc
                  requireDocs={serviceDetail?.requireDocs}
                  importantNotes={serviceDetail?.importantDocs}
                  sectionTitle={serviceDetail.allTitles.section_4_title}
                  line={serviceDetail.allTitles.section_4_line}
                />
              )} */}

            {/* <AddonModal /> */}

            {serviceDetail?.channelPartner &&
              serviceDetail?.channelPartner.length > 0 &&
              serviceDetail?.allTitles && (
                <ChannelPartner
                  channelPartner={serviceDetail?.channelPartner}
                  sectionTitle={serviceDetail.allTitles.section_5_title}
                  line={serviceDetail.allTitles.section_5_line}
                />
              )}

            {serviceDetail?.serviceSteps &&
              serviceDetail?.serviceSteps.length > 0 &&
              serviceDetail?.allTitles && (
                <ServiceStep
                  serviceSteps={serviceDetail?.serviceSteps}
                  sectionTitle={serviceDetail.allTitles.section_7_title}
                  line={serviceDetail.allTitles.section_7_line}
                />
              )}

            {serviceDetail?.serviceRejection &&
              serviceDetail?.serviceRejection.length > 0 &&
              serviceDetail?.allTitles && (
                <ServiceRejection
                  serviceRejection={serviceDetail?.serviceRejection}
                  sectionTitle={serviceDetail.allTitles.section_6_title}
                  line={serviceDetail.allTitles.section_6_line}
                />
              )}
            {serviceDetail?.aboutService &&
              serviceDetail?.aboutService?.AboutDescription &&
              serviceDetail?.allTitles && (
                <AboutService
                  aboutService={serviceDetail?.aboutService}
                  sectionTitle={serviceDetail.allTitles.section_8_title}
                  line={serviceDetail.allTitles.section_8_line}
                />
              )}

            {/* {serviceDetail?.serviceGallery && serviceDetail?.allTitles && (
              <ServiceGallery
                serviceGallery={serviceDetail?.serviceGallery}
                sectionTitle={serviceDetail.allTitles.section_9_title}
                line={serviceDetail.allTitles.section_9_line}
              />
            )} */}

            {serviceDetail?.serviceEmirates &&
              serviceDetail?.serviceEmirates.length > 0 &&
              serviceDetail?.allTitles &&
              (serviceDetail?.serviceEmirates.length == 1 ? (
                <>
                  <div className="modal-mainn">
                    <ServiceEmirateSingle
                      serviceEmirates={serviceDetail?.serviceEmirates}
                      sectionTitle={serviceDetail.allTitles.section_10_title}
                      line={serviceDetail.allTitles.section_10_line}
                    />
                  </div>
                </>
              ) : (
                <>
                  <div className="modal-mainn">
                    <ServiceEmirate
                      serviceEmirates={serviceDetail?.serviceEmirates}
                      sectionTitle={serviceDetail.allTitles.section_10_title}
                      line={serviceDetail.allTitles.section_10_line}
                    />
                  </div>
                </>
              ))}

            {serviceDetail?.serviceReview && serviceDetail?.allTitles && (
              <ServiceReview
                serviceReview={serviceDetail?.serviceReview}
                sectionTitle={serviceDetail.allTitles.section_11_title}
                line={serviceDetail.allTitles.section_11_line}
              />
            )}

            {serviceDetail?.serviceFaq &&
              serviceDetail?.serviceFaq.length > 0 &&
              serviceDetail?.allTitles && (
                <ServiceFaq
                  serviceFaqs={serviceDetail?.serviceFaq}
                  sectionTitle={serviceDetail.allTitles.section_12_title}
                  line={serviceDetail.allTitles.section_12_line}
                />
              )}
          </>
        )}
      </Modal.Body>
      <Modal.Footer className="p-0 border-0 rounded-0">
        <div className="w-100 p-0 m-0">
          <p className="item-count rounded-0 bg-beige text-noti font-11 p-2 mb-0 px-2 ff-medium d-flex align-items-center gap-2">
            <span>
              <svg
                width="13"
                height="12"
                viewBox="0 0 13 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.49993 0C7.06429 0 7.59023 0.275972 7.91229 0.736909L7.97434 0.83146L12.7693 8.83759C12.915 9.08997 12.9943 9.3752 12.9997 9.66658C13.0051 9.95796 12.9365 10.2459 12.8003 10.5036C12.6641 10.7612 12.4647 10.98 12.2208 11.1396C11.977 11.2992 11.6966 11.3942 11.406 11.4159L11.2907 11.4206H1.70264C1.41172 11.4173 1.12637 11.3404 0.873229 11.197C0.620088 11.0536 0.407407 10.8484 0.255039 10.6005C0.102671 10.3527 0.0155832 10.0703 0.00190455 9.77967C-0.0117741 9.48905 0.0484024 9.19971 0.176817 8.93864L0.235321 8.82932L5.02789 0.829096C5.18134 0.576061 5.3974 0.36684 5.65525 0.221616C5.91309 0.0763913 6.20401 6.51029e-05 6.49993 0ZM6.49993 5.51352H5.90899L5.83985 5.51766C5.69622 5.53474 5.56384 5.60391 5.4678 5.71206C5.37175 5.82021 5.3187 5.95982 5.3187 6.10447C5.3187 6.24911 5.37175 6.38873 5.4678 6.49687C5.56384 6.60502 5.69622 6.67419 5.83985 6.69128L5.90899 6.69541V8.46825L5.91312 8.53739C5.92868 8.6693 5.98822 8.79212 6.08214 8.88604C6.17606 8.97996 6.29888 9.0395 6.43079 9.05506L6.49993 9.05919H7.09088L7.16002 9.05506C7.29193 9.0395 7.41475 8.97996 7.50867 8.88604C7.60259 8.79212 7.66213 8.6693 7.67769 8.53739L7.68182 8.46825L7.67769 8.39911C7.66356 8.27854 7.61265 8.16525 7.53187 8.07464C7.45109 7.98403 7.34436 7.92049 7.2262 7.89267L7.16002 7.88085L7.09088 7.8773V6.10447L7.08674 6.03533C7.07119 5.90342 7.01164 5.78059 6.91772 5.68667C6.8238 5.59275 6.70098 5.53321 6.56907 5.51766L6.49993 5.51352ZM6.50584 3.74068L6.43079 3.74482C6.28716 3.76191 6.15479 3.83107 6.05874 3.93922C5.96269 4.04737 5.90965 4.18699 5.90965 4.33163C5.90965 4.47627 5.96269 4.61589 6.05874 4.72404C6.15479 4.83219 6.28716 4.90135 6.43079 4.91844L6.49993 4.92258L6.57498 4.91844C6.71861 4.90135 6.85099 4.83219 6.94703 4.72404C7.04308 4.61589 7.09613 4.47627 7.09613 4.33163C7.09613 4.18699 7.04308 4.04737 6.94703 3.93922C6.85099 3.83107 6.71861 3.76191 6.57498 3.74482L6.50584 3.74068Z"
                  fill="#CF770C"
                />
              </svg>
            </span>
            <span>{serviceDetail?.serviceReview.stickyNotes}</span>
          </p>
        </div>
        {serviceDetail?.isPackage && (
          <div className="d-flex align-items-center justify-content-between w-100 px-3 py-2">
            <div>
              <h6 className="mb-0 ff-semibold font-16">
                <span className="ff-currency ff-medium font-16"></span>
                {selectedService?.totalPrice}
              </h6>
              <p className="text-black font-12 text-black-50 mb-0">
                {selectedService?.Name}
              </p>
            </div>
            <button
              className="btn btn-primary w-25 font-14 ff-semibold py-3  bt--cart"
              onClick={handleProceedButton}
            >
              PROCEED
            </button>
          </div>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default UpdateModel;
